/**
 * Expected daemons not running, as Machine problems rows (WI 34293 x WI 34278).
 *
 * The exceptions-first layout has no separate daemons tile, so each missing
 * unit from a Control Center's daemons report (see daemons.logic.ts) becomes a
 * machine alert. A unit that is installed but not running (not loaded,
 * failing, no pid, last run exited) is critical; one that is not installed at
 * all is a warning, as is a manifest label missing from (or not scoped to the
 * host in) Ryn_Core's daemon catalog. A row from a report older than DAEMON_STALE_MS cannot
 * vouch for the unit, so it is a warning that says how old the report is.
 */
import type { Alert } from './attention.logic';
import { CATALOG_DRIFT_REASONS, type DaemonRow } from './daemons.logic';

export function daemonAlerts(rows: readonly DaemonRow[]): Alert[] {
  return rows.map((r) => {
    // Not installed, or a manifest label the catalog does not vouch for (WI
    // 34333): worth fixing, but nothing that was running has stopped.
    const notRunningFault =
      r.reason === 'not-installed' || CATALOG_DRIFT_REASONS.has(r.reason ?? '');
    return {
      id: `daemon|${r.host}|${r.fullLabel}`,
      severity: !r.stale && !notRunningFault ? 'crit' : 'warn',
      kind: 'machine',
      category: 'machine',
      title: `${r.label} on ${r.host}`,
      detail: r.stale
        ? `${r.reasonText} · daemon report is stale`
        : `Daemon ${r.reasonText}`,
      action: { type: 'open-machine', label: 'Open machine', target: r.host },
      weight: r.stale ? 0 : 1,
    };
  });
}
